import React from 'react';
import { withRouter } from "react-router-dom";
import IndividualEntitiesComponent from './IndividualEntities.component';



const IndividualEntitiesLanding = () => { 
    return <IndividualEntitiesComponent />
}
export default withRouter(IndividualEntitiesLanding);